import { useClientClaims } from "./useClientClaims";

export function useHasInactiveClaim(clientId: string | undefined) {
  const { data: hasInactiveClaim = false } = useClientClaims(clientId, (claims) =>
    claims.some((c) => !c.isCompleted && (c.isCreditorInactive || c.isRepresentativeInactive === true))
  );

  return hasInactiveClaim;
}
